import React from 'react';
import UserManagement from '../../components/admin/UserManagement';

/**
 * AdminUsersPage - User management page for administrators
 * Accessible at /admin/users
 * Provides user search, filtering, editing, and moderator creation
 */
const AdminUsersPage: React.FC = () => {
  return <UserManagement />;
};

export default AdminUsersPage; 